

export { singleton as PageReady } from './src/index';
